module.exports = __webpack_public_path__ + "static/media/fail.b446aa9b.webp";